import React, { ComponentProps } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ExecutiveOrganizationChart } from '../StructuralPageToPageTree/partials/ExecutiveOrganizationChart/ExecutiveOrganizationChart';
import { IndexTree } from './partials/IndexTree';
import { DateFormat, DateFormats } from '../../_lib/components/DateFormat';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { ConnectedOrganizationsAndContactPersonsTree } from './partials/ConnectedOrganizationsAndContactPersonsTree';
import { IConnectedPage } from '../../types/api/connectedPages/IConnectedPage';

type ExecutiveOrganisationChartPrint = {
  index: IConnectedPage[];
  imageUrl: string;
  createDate: string;
  gvpInfos: ExecutiveOrganizationChart[];
};

function ExecutiveOrganisationChartPrint({ index, imageUrl, createDate, gvpInfos }: ExecutiveOrganisationChartPrint) {
  const { t } = useSonTranslation('ExecutiveOrganisationChartPrint');

  return (
    <div className="eoc">
      <div className="eoc__cover-sheet">
        <img src={imageUrl} alt={index?.at(0)?.childPages?.at(0)?.title} className="eoc__logo" />
        <header className="eoc__header">
          <h1 className="eoc__heading">{t('headline')}</h1>
          <p className="eoc__date">
            <dfn className="eoc__dfn">{t('createDate')}: </dfn>
            <DateFormat date={createDate} format={DateFormats.DAY_MONTH_AND_YEAR} />
          </p>
        </header>
      </div>
      {index && index.length ? (
        <>
          <h2 className="font-bold-22-28">{t('index')}</h2>
          <IndexTree pages={index} />
        </>
      ) : null}
      {gvpInfos && gvpInfos.length ? <h2 className="invisible">{t('orgUnits')}</h2> : null}
      {gvpInfos && gvpInfos.length
        ? gvpInfos.map((item: any) => {
            return (
              <div id={item.id} key={item.id} className="eoc__org-unit">
                <ExecutiveOrganizationChart gvpInfo={item.gvpInfo} />
                {item.pageTreeWithFilters?.connectedPages &&
                item.pageTreeWithFilters.connectedPages.length > 0 &&
                item.pageTreeWithFilters.connectedPages.at(0).childPages &&
                item.pageTreeWithFilters.connectedPages.at(0).childPages.length > 0 ? (
                  <div className="eoc__org-tree-table-container">
                    <div className="eoc__org-tree-table-header">
                      <div
                        className="eoc__org-tree-table-column
                          font-regular-16-24"
                      >
                        {t('glossary:task')}
                      </div>
                      <div
                        className="eoc__org-tree-table-column
                          font-regular-16-24"
                      >
                        {t('glossary:contactPerson')}
                      </div>
                    </div>
                    <ConnectedOrganizationsAndContactPersonsTree
                      connectedPages={item.pageTreeWithFilters.connectedPages[0].childPages}
                    />
                  </div>
                ) : null}
              </div>
            );
          })
        : null}
    </div>
  );
}

export const ExecutiveOrganisationChartPrintBlock = asBlock(
  ExecutiveOrganisationChartPrint,
  BlockType.executiveorganisationchartprint
);
export type ExecutiveOrganisationChartPrintBlock = ComponentProps<typeof ExecutiveOrganisationChartPrintBlock>;
